import { useState, useEffect, useRef } from "react";
import {
    getAllCategories
  } from "../Utils/Utils";
import Tabs from "./MUI/Tabs";


const CategoriesSection = ({setSelectedCategory, setSelectedSubCategory , scrollIntoView , sectionRef}) => {
    const [categories, setCategories] = useState([]);
    
    useEffect(() => {
      const fetchCategories = async () => {
        console.log("fetching categories.....");
        try {
          console.log("fetching categories.....");
          const data = await getAllCategories();
          setCategories(data);
          console.log(data);
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      };
  
      fetchCategories();
    }, []);
  
    const tabsData = categories.map((cat) => ({
      buttonContent: <p>{cat.categoryName}</p>,
      content: (
        <div className="tabs-content">
          {cat.subcategories
            .sort((a, b) => {
              // If order is not defined for some items, you might want to handle that case
              const orderA = a.order !== undefined ? a.order : Infinity;
              const orderB = b.order !== undefined ? b.order : Infinity;
              return orderA - orderB;
            })
            .map((sub, index) => (
              <div
                key={index}
                className="tab-grid-item flex align-items-center"
                onClick={() => {
                    setSelectedCategory(cat.categoryName);
                    
                    
                    setTimeout(() => {
                    setSelectedSubCategory(sub.subcategoryName);
                    scrollIntoView(3)
                    }, 500);
                }}
              >
                <img
                  alt={sub.name}
                  src={
                    sub.subcategoryImagesUrls
                      ? sub.subcategoryImagesUrls[0]
                      : null
                  }
                />
                <p className="small-text mx-20">{sub.subcategoryName} </p>
              </div>
            ))}
        </div>
      ),
    }));
  
    return (
      <div
      ref={sectionRef}
        id="section-tabs"
        className="section Categories-section w-full h-full flex-column justify-center px-80 box-sizing"
      >
        <p className="sec-text bold">
          Découvrez les catégories de produits Active Fitness
        </p>
        <p className="small-text w-1-2 center- my-20">
          Explorez notre gamme diversifiée d’équipements de fitness, d’accessoires
          sportifs et vêtements. Chaque catégorie offre une sélection
          soigneusement organisée pour s’adapter votre parcours de remise en
          forme. Cliquez sur les onglets pour produits pour vos besoins.
        </p>
        <Tabs tabs={tabsData} />
      </div>
    );
  };

  
  

export default CategoriesSection;